export const trafficIntensityTooltipRows = [
    { field: 'CarLightTruck', label: 'Легковые' },
    { field: 'TwoAxleTruck', label: 'Грузовые, двухосные' },
    { field: 'ThreeAxleTruck', label: 'Грузовые, трёхосные' },
    { field: 'FourAxleTruck', label: 'Грузовые, четырёхосные' },
    { field: 'FourAxleRoadTrain', label: 'Четырёхосные автопоезда' },
    { field: 'FiveAxleRoadTrain', label: 'Пятиосные автопоезда' },
    { field: 'ThreeAxleSemiTrailerTruck', label: 'Трёхосные седельные автопоезда' },
    { field: 'FourAxleSemiTrailerTruck', label: 'Четырёхосные седельные автопоезда' },
    { field: 'FiveAxleSemiTrailerTruckWith2AxleTractor', label: 'Пятиосные седельные, 2-осный тягач' },
    { field: 'FiveAxleSemiTrailerTruckWith3AxleTractor', label: 'Пятиосные седельные, 3-осный тягач' },
    { field: 'SixAxleSemiTrailerTruck', label: 'Шестиосные седельные автопоезда' },
    { field: 'SevenAxleTruck', label: 'Семь осей и более' },
    { field: 'Bus', label: 'Автобусы' },
    { field: 'Motorcycle', label: 'Мотоциклы' },
] as const;

export const trafficIntensityTooltipPropertyNames = [
    'EventYear',
    'TotalIntensity',
    ...trafficIntensityTooltipRows.map(({ field }) => field),
].join(',');
